import { apiConcurso } from './cliente';

/** Formulário de cadastro vigente, com labels e opções no idioma `locale`. */
export const getFormularioProdutor = (slug, locale) =>
  apiConcurso.get('/api/v1/produtores/formulario-atual', {
    headers: { 'X-Tenant-Slug': slug, ...(locale ? { 'Accept-Language': locale } : {}) },
  });

export const salvarCadastroProdutor = (data) => apiConcurso.post('/api/v1/produtores', data);

/** `data` = true quando o CPF/CNPJ já é de outro produtor (`produtorId` exclui o próprio). */
export const verificarDocumentoProdutor = (documento, produtorId) =>
  apiConcurso.get(`/api/v1/produtores/documentos/${documento}`, { params: produtorId ? { produtorId } : {} });

/** Produtores do concurso, paginado (endpoint do backoffice) — usado no "acessar como" do Master. */
export const listarProdutoresBackoffice = (concursoId, params) =>
  apiConcurso.get(`/api/v1/backoffices/produtores/concursos/${concursoId}`, { params });
